import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../index'

const { env } = window

const useVisualizations = (categoryId) => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()

  const getVisualizations = async (categoryId) => {
    const url = encodeURI(
      `${env.apiUrl}/categories/${categoryId}/visualizations`
    )
    const response = await securedFetch(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['visualizations', categoryId],
    queryFn: () => getVisualizations(categoryId),
    enabled: !!categoryId,
    refetchOnWindowFocus: false
  })

  useEffect(() => {
    if (query.isError) {
      handleError(query.error, 'Error getting visualizations')
    }
  }, [query.isError, query.error, handleError])

  return {
    visualizations: query.data
  }
}

export { useVisualizations }
